export default __webpack_public_path__ + "static/media/2C2A1506.ddfe1dda.jpg";